import { GlobalSearchFieldFilterPipe } from './../../pipes/global-search-fields-filter.pipe';
import { GlobalSearchModuleFilterPipe } from './../../pipes/global-search-module-filter.pipe';
import { GlobalSearchModuleSearch, ProductSubModule, PurchaseSubModule } from './models/module-search.enum';
import { ObjectNames } from './../../../../shared/constants';
import { Router } from '@angular/router';
import { GlobalSearchPath } from './../../constants/global-search-path';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { ElasticSearchResultsViewModels, ElasticSearchResultModels, DisplayRules } from './models/elastic-search-results-view.models';
import { ElasticGlobalSearchService } from './services/elastic-global-search.service';
import { Subject, Subscription } from 'rxjs';
import { FormControl } from '@angular/forms';
import { Component, OnInit, OnDestroy, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { AccountService } from 'src/app/accounts/accountService';
import { SearchHistory, SingleHistory } from './models/search-history.model';
import { ModuleFieldSuggestion, ModuleSuggestion } from './models/module-search.model';
import { removeHTMLTags } from '../../helpers/remove-html-tags.helper';
import { AccountModuleName, BillOrderModuleName, CaseModuleName, ContactModuleName, CreditMemo, CustomerRmaModuleName, EstimateModuleName, InvoiceModuleName, LeadModuleName, OpportunityModuleName, ProductModuleName, PurchaseOrderModuleName, SalesOrderModuleName, SerialNoModuleName, TerritoryModuleName } from '../../constants/modules.constant';
import { GlobalSearchModuleName } from '../../constants/module-name.constant';

@Component({
    selector: 'app-elastic-global-search',
    templateUrl: './elastic-global-search.component.html',
    styleUrls: ['./elastic-global-search.component.scss'],
    providers: [GlobalSearchFieldFilterPipe, GlobalSearchModuleFilterPipe]
})
export class ElasticGlobalSearchComponent implements OnInit, OnDestroy {

    subscription: Subscription = new Subscription();
    globalSearchPath = GlobalSearchPath;
    globalSearchModuleName = GlobalSearchModuleName;
    tabSearchResults: ElasticSearchResultModels[] = [];


    selectedTabIndex: number;

    searchControl: FormControl = new FormControl();
    showSearchSuggestions: boolean = false;

    loadingSearchResults: boolean = false;
    spinnerOnTabChange: boolean = false;
    searchResults: ElasticSearchResultsViewModels[] = [];

    globalSearchSettings: any;
    accountDisplayRules: DisplayRules[] = [];
    contactDisplayRules: DisplayRules[] = [];
    leadDisplayRules: DisplayRules[] = [];
    opportunityDisplayRules: DisplayRules[] = [];
    productDisplayRules: DisplayRules[] = [];
    purchaseDisplayRules: DisplayRules[] = [];
    billOrderDisplayRules: DisplayRules[] = [];
    salesOrderDisplayRules: DisplayRules[] = [];
    estimateDisplayRules: DisplayRules[] = [];
    invoiceDisplayRules: DisplayRules[] = [];
    casesDisplayRules: DisplayRules[] = [];
    territoryDisplayRules: DisplayRules[] = [];
    serialNoDisplayRules: DisplayRules[] = [];
    customerRMADisplayRules: DisplayRules[] = [];
    creditMemoDisplayRules: DisplayRules[] = [];
    searchHistory: SearchHistory[] = [];
    searchHistoryMsg: boolean = true;
    loadingHistoryResult: boolean = false;
    isSeachFromHistoty: boolean = false;
    userId: number;

    moduleSuggestionResults: ModuleSuggestion[] = [];
    moduleSearchValue: string = "";
    moduleFieldsSuggestionResults: ModuleFieldSuggestion[] = [];
    moduleFieldsSearchValue: string = "";
    searchFocusElement: number = -1;
    moduleSearchType = GlobalSearchModuleSearch.MODULE;
    navigationHiddens: string[] = [this.globalSearchPath.SerialNo, this.globalSearchPath.BillOrder, this.globalSearchPath.Territory, this.globalSearchPath.Purchases];

    /* Subject to unsubscribe */
    private ngUnsubscribe = new Subject<void>();

    @ViewChild('SearchInput') SearchInput: ElementRef;

    selectedModuleSuggestion: any;

    constructor(
        private router: Router,
        private globalSearchService: ElasticGlobalSearchService,
        private accountService: AccountService,
        private changeDetectorRef: ChangeDetectorRef,
        private globalSearchModuleFilterPipe: GlobalSearchModuleFilterPipe,
        private globalSearchFieldFilterPipe: GlobalSearchFieldFilterPipe,
    ) { }

    /**
     * As global searh result come from elastic search and
     * results from elastic search come for specific module
     * and all property in a specific modules naming convention
     * is not camelCase, all are small case
     * so here we need to bind as that way
     */

    ngOnInit(): void {
        this.initSearch();
    }

    getUser(): void {
        let user = JSON.parse(localStorage.getItem('user'));
        this.userId = user?.userId;

    }

    initSearch() {
        this.searchControl.valueChanges.pipe(
            debounceTime(700),
            distinctUntilChanged())
            .subscribe((value: any) => {
                this.searchFocusElement = 0;
                if (value?.length > 0) {
                    const regexForModuleAndField = /^(Accounts|accounts|Leads|leads|Contacts|contacts|Opportunities|opportunities|Cases|cases):\w+\s?\w+?:$/;
                    const regexForModuleFieldSearch = /^(Accounts|accounts|Leads|leads|Contacts|contacts|Opportunities|opportunities|Cases|cases):@$/;
                    const regexForModuleSearch = /^(Accounts|accounts|Leads|leads|Contacts|contacts|Opportunities|opportunities|Cases|cases):$/;
                    const matchValueForModuleField = value.match(regexForModuleFieldSearch);
                    const matchValueForModule = value.match(regexForModuleSearch);
                    const matchValueForModuleAndField = value.match(regexForModuleAndField);

                    const splitedSearchValue = value.split(':');

                    if (value.startsWith('@')) {
                        this.searchHistory = [];
                        this.searchResults = [];
                        this.moduleFieldsSuggestionResults = [];
                        this.moduleSearchValue = value.trim().replace('@', '');
                        this.moduleSearchType = GlobalSearchModuleSearch.MODULE;
                        this.getModuleSuggestion();
                    }
                    else if (matchValueForModule !== null) {
                        return;
                    }
                    else if (matchValueForModuleField !== null || (splitedSearchValue.length >= 1 && splitedSearchValue[1]?.startsWith('@'))) {
                        this.searchHistory = [];
                        this.searchResults = [];
                        this.moduleSuggestionResults = [];
                        const moduleName = splitedSearchValue[0];
                        this.moduleFieldsSearchValue = splitedSearchValue[1]?.trim().replace('@', '');
                        this.moduleSearchType = GlobalSearchModuleSearch.FIELD;
                        this.getModuleWiseFieldSuggestion(moduleName);
                    }
                    else if (matchValueForModuleAndField != null) {
                        return;
                    }
                    else {
                        this.searchHistory = [];
                        this.moduleSuggestionResults = [];
                        this.moduleFieldsSuggestionResults = [];
                        this.moduleSearchType = GlobalSearchModuleSearch.VALUE;
                        this.onGlobalSearch(value);
                    }
                } else {
                    this.searchResults = [];
                    this.moduleSuggestionResults = [];
                    this.moduleFieldsSuggestionResults = [];
                    this.findSearchHistory();
                }
            });
    }

    getModuleSuggestion(): void {
        this.loadingSearchResults = true;
        this.moduleSuggestionResults = [];
        this.globalSearchService.getModuleSuggestions()
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe({
                next: (response) => {
                    this.moduleSuggestionResults = response;
                    this.loadingSearchResults = false;
                },
                error: (() => {
                    this.loadingSearchResults = false;
                }),
                complete: (() => {
                })
            });
    }

    getModuleWiseFieldSuggestion(keyword: string): void {
        this.loadingSearchResults = true;
        this.globalSearchService.getModuleWiseFieldSuggestions(keyword)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe({
                next: (response) => {
                    this.moduleFieldsSuggestionResults = response[0]?.fields;
                    this.loadingSearchResults = false;
                },
                error: (() => {
                    this.loadingSearchResults = false;
                }),
                complete: (() => {
                })
            });
    }

    onGlobalSearch(searchKeywords: string, selectedTabName?: string) {

        if (selectedTabName) {
            this.spinnerOnTabChange = true;
            this.loadingSearchResults = false;
            this.globalSearchService.getElasticSearchResults(searchKeywords).subscribe(results => {
                this.searchHistoryMsg = false;
                if (!this.isSeachFromHistoty) {
                    this.storeSearchHistory(searchKeywords);
                }
                this.formatSearchResults(results, selectedTabName);
                this.spinnerOnTabChange = false;
            }, (error) => {
                this.spinnerOnTabChange = false;
            });

        } else {
            this.loadingSearchResults = true;
            //this.subscription.add(
            this.globalSearchService.getElasticSearchResults(searchKeywords).subscribe(results => {
                this.searchHistoryMsg = false;
                if (!this.isSeachFromHistoty) {
                    this.storeSearchHistory(searchKeywords);
                }
                this.formatSearchResults(results);
                this.loadingSearchResults = false;
            }, (error) => {
                this.loadingSearchResults = false;
            });
        }

        //);
    }

    findSearchHistory(): void {
        // this.moduleSuggestionResults = [];
        // this.moduleFieldsSuggestionResults = [];
        this.searchHistory = [];
        let historyKey = JSON.parse(localStorage.getItem('searchHistory')) || [];
        if (historyKey.length > 0) {
            this.searchHistoryMsg = false;
            let userIndex = historyKey.findIndex(x => x.userId == this.userId);
            if (historyKey[userIndex]?.history?.length < 5) {
                this.searchHistory = historyKey[userIndex]?.history?.sort((a, b) => {
                    return b.unixDateTime - a.unixDateTime;
                });
            }
            else {
                let lastFiveObject = historyKey[userIndex]?.history?.slice(-5);
                this.searchHistory = lastFiveObject.sort((a, b) => {
                    return b.unixDateTime - a.unixDateTime;
                });
            }
        }

    }

    storeSearchHistory(searchKeyword: string) {
        let SearchHistory: SearchHistory =
        {
            userId: this.userId,
            history: [
                {
                    value: searchKeyword,
                    unixDateTime: new Date().getTime()
                }
            ]
        };

        let historyKey = JSON.parse(localStorage.getItem('searchHistory'));
        if (historyKey === null) {
            historyKey = [];
        }

        let userIndex = historyKey.findIndex(x => x.userId == this.userId);
        if (userIndex > -1) {
            let searchData = {
                value: searchKeyword,
                unixDateTime: new Date().getTime()
            }
            historyKey[userIndex].history.push(searchData);
        }
        else {
            historyKey.push(SearchHistory);
        }

        let availableUserIndex = historyKey.findIndex(x => x.userId == this.userId);
        let maxObj = 10;
        if (historyKey[availableUserIndex].history.length > maxObj) {
            historyKey[availableUserIndex].history.shift();
        }

        localStorage.setItem('searchHistory', JSON.stringify(historyKey));
    }

    onSearchInputClick(): void {
        this.searchFocusElement = 0;
        if (!this.userId) {
            this.getUser();
        }
        this.findSearchHistory();
    }

    removeHistory(history: SingleHistory) {

        /**
         * Set Time out has been used because DOM binding doesn't
         * behave properly
         */

        let historyKey = JSON.parse(localStorage.getItem('searchHistory'));
        let userIndex = historyKey.findIndex(x => x.userId == this.userId);
        let index = historyKey[userIndex].history.findIndex(x => x.unixDateTime == history.unixDateTime);
        historyKey[userIndex].history.splice(index, 1);

        setTimeout(() => {
            if (historyKey[userIndex].history.length < 5) {
                this.searchHistory = historyKey[userIndex].history.sort((a, b) => {
                    return b.unixDateTime - a.unixDateTime;
                });
            }
            else {
                let lastFiveObject = historyKey[userIndex].history.slice(-5);
                this.searchHistory = lastFiveObject.sort((a, b) => {
                    return b.unixDateTime - a.unixDateTime;
                });
            }
            localStorage.setItem('searchHistory', JSON.stringify(historyKey));
            if (this.searchHistory.length == 0) {
                this.searchHistoryMsg = true;
            }
        }, 0);
        //setTimeout(() => {localStorage.setItem('searchHistory', JSON.stringify(this.searchHistory));}, 0);

    }

    formatSearchResults(results: any, selectedTabName?: string) {
        if (!selectedTabName) {
            this.searchResults = [];
            this.accountDisplayRules = [];
            this.contactDisplayRules = [];
            this.leadDisplayRules = [];
            this.opportunityDisplayRules = [];
            this.productDisplayRules = [];
            this.casesDisplayRules = [];
            this.serialNoDisplayRules = [];
        }
        // Account Details Format
        if (results?.accountResultCount > 0) {
            //this.getAccountSettings();
            const searchResults: ElasticSearchResultModels[] = [];

            let flatData = this.getAccountFlatData(results?.accountResults);

            flatData.map(details => {
                searchResults.push({
                    title: details?.businessname,
                    subTitle: `Channel: ${details?.channelname}`,
                    contentDetails: details
                })
            });

            const resultExist = this.searchResults.find(m => m.modulePath === this.globalSearchPath.Account);
            if (resultExist) {
                resultExist.searchResults = [...searchResults];
            } else {
                this.searchResults.push({
                    tabName: `Accounts (${results?.accountResultCount})`,
                    modulePath: this.globalSearchPath.Account,
                    moduleName: this.globalSearchModuleName.Account,
                    searchResults: [...searchResults]
                });
            }

            //this.searchResults.searchResults = this.getAccountFlatCols(this.searchResults.searchResults);

            if (results?.fieldDisplayRule[0]?.accountField?.length > 0) {
                this.accountDisplayRules = [];
                results?.fieldDisplayRule[0]?.accountField.map(rules => {
                    this.accountDisplayRules.push({
                        name: rules?.name,
                        fieldName: rules?.fieldName
                    });
                });
            }
        }

        //Contact Details Format
        if (results?.contactResultCount > 0) {
            const searchResults: ElasticSearchResultModels[] = [];

            let flatData = this.getContactFlatData(results?.contactResults);

            flatData.map(details => {
                searchResults.push({
                    title: details?.contactfirstname + ' ' + details?.contactlastname,
                    subTitle: '',
                    contentDetails: details
                })
            });
            const resultExist = this.searchResults.find(m => m.modulePath === this.globalSearchPath.Contact);
            if (resultExist) {
                resultExist.searchResults = [...searchResults];
            } else {
                this.searchResults.push({
                    tabName: `Contacts (${results?.contactResultCount})`,
                    modulePath: this.globalSearchPath.Contact,
                    moduleName: this.globalSearchModuleName.Contact,
                    searchResults: [...searchResults]
                });
            }


            if (results?.fieldDisplayRule[0]?.contactField?.length > 0) {
                this.contactDisplayRules = [];
                results?.fieldDisplayRule[0]?.contactField.map(rules => {
                    this.contactDisplayRules.push({
                        name: rules?.name,
                        fieldName: rules?.fieldName
                    });
                });
            }
        }

        //Lead Details Format
        if (results?.leadResultCount > 0) {
            const leadResults: ElasticSearchResultModels[] = [];

            let flatData = this.getLeadFlatData(results?.leadResults);

            flatData.map(details => {
                leadResults.push({
                    title: details?.businessname,
                    subTitle: `Channel: ${details?.channelname}`,
                    contentDetails: details
                })
            });

            const resultExist = this.searchResults.find(m => m.modulePath === this.globalSearchPath.Lead);
            if (resultExist) {
                resultExist.searchResults = [...leadResults];

            } else {
                this.searchResults.push({
                    tabName: `Leads (${results?.leadResultCount})`,
                    modulePath: this.globalSearchPath.Lead,
                    moduleName: this.globalSearchModuleName.Lead,
                    searchResults: [...leadResults]
                });
            }


            if (results?.fieldDisplayRule[0]?.leadField?.length > 0) {
                this.leadDisplayRules = [];
                results?.fieldDisplayRule[0]?.leadField.map(rules => {
                    this.leadDisplayRules.push({
                        name: rules?.name,
                        fieldName: rules?.fieldName
                    });
                });
            }
        }

        //Opportunity Details Format
        if (results?.opprtunityResultCount > 0) {
            const opprtunityResults: ElasticSearchResultModels[] = [];

            let flatData = this.getOpportunityFlatData(results?.opprtunityResults);

            flatData.map(details => {
                opprtunityResults.push({
                    title: details?.name,
                    subTitle: `Channel: ${details?.channelname}`,
                    contentDetails: details
                })
            });

            const resultExist = this.searchResults.find(m => m.modulePath === this.globalSearchPath.Opportunity);
            if (resultExist) {
                resultExist.searchResults = [...opprtunityResults];
            } else {
                this.searchResults.push({
                    tabName: `Opportunities (${results?.opprtunityResultCount})`,
                    modulePath: this.globalSearchPath.Opportunity,
                    moduleName: this.globalSearchModuleName.Opportunity,
                    searchResults: [...opprtunityResults]
                });
            }


            if (results?.fieldDisplayRule[0]?.opportunityField?.length > 0) {
                this.opportunityDisplayRules = [];
                results?.fieldDisplayRule[0]?.opportunityField.map(rules => {
                    this.opportunityDisplayRules.push({
                        name: rules?.name,
                        fieldName: rules?.fieldName
                    });
                });
            }
        }

        //Product Details Format
        if (results?.productResultCount > 0) {
            const productResults: ElasticSearchResultModels[] = [];

            let flatData = this.getProductsFlatData(results?.productResults);

            flatData.map(details => {
                productResults.push({
                    title: details?.name || details?.itemno,
                    subTitle: `Channel: ${details?.channelname}`,
                    contentDetails: details
                })
            });

            const resultExist = this.searchResults.find(m => m.modulePath === this.globalSearchPath.Product);
            if (resultExist) {
                resultExist.searchResults = [...productResults];
            } else {
                this.searchResults.push({
                    tabName: `Products (${results?.productResultCount})`,
                    modulePath: this.globalSearchPath.Product,
                    moduleName: this.globalSearchModuleName.Product,
                    searchResults: [...productResults]
                });
            }

            if (results?.fieldDisplayRule[0]?.productField?.length > 0) {
                this.productDisplayRules = [];
                results?.fieldDisplayRule[0]?.productField.map(rules => {
                    this.productDisplayRules.push({
                        name: rules?.name,
                        fieldName: rules?.fieldName
                    });
                });
            }
        }
        //PurchaseOrder Result
        if (results?.purchaseOrderResultCount > 0) {

            const purchaseOrderResults: ElasticSearchResultModels[] = [];

            let flatData = this.getPurchaseOrderFlatData(results?.purchaseOrderResults);

            flatData.map(details => {
                purchaseOrderResults.push({
                    title: details?.name || details?.ponumber,
                    subTitle: ``,
                    contentDetails: details
                })
            });

            const resultExist = this.searchResults.find(m => m.modulePath === this.globalSearchPath.Purchases);
            if (resultExist) {
                resultExist.searchResults = [...purchaseOrderResults];
            } else {
                this.searchResults.push({
                    tabName: `PurchaseOrder (${results?.purchaseOrderResultCount})`,
                    modulePath: this.globalSearchPath.Purchases,
                    moduleName: this.globalSearchModuleName.Purchases,
                    searchResults: [...purchaseOrderResults]
                });
            }

            if (results?.fieldDisplayRule[0]?.purchaseOrderField?.length > 0) {
                this.purchaseDisplayRules = [];
                results?.fieldDisplayRule[0]?.purchaseOrderField.map(rules => {
                    this.purchaseDisplayRules.push({
                        name: rules?.name,
                        fieldName: rules?.fieldName
                    });
                });
            }
        }

        //Bill-Order Result
        if (results?.billOrderResultCount > 0) {

            const billOrderResults: ElasticSearchResultModels[] = [];

            let flatData = this.getBillOrderFlatData(results?.billOrderResults);

            flatData.map(details => {
                billOrderResults.push({
                    title: details?.name || details?.billnumber,
                    subTitle: ``,
                    contentDetails: details
                })
            });

            const resultExist = this.searchResults.find(m => m.modulePath === this.globalSearchPath.BillOrder);
            if (resultExist) {
                resultExist.searchResults = [...billOrderResults];
            } else {
                this.searchResults.push({
                    tabName: `BillOrder (${results?.billOrderResultCount})`,
                    modulePath: this.globalSearchPath.BillOrder,
                    moduleName: this.globalSearchModuleName.BillOrder,
                    searchResults: [...billOrderResults]
                });
            }

            if (results?.fieldDisplayRule[0]?.billOrderField?.length > 0) {
                this.billOrderDisplayRules = [];
                results?.fieldDisplayRule[0]?.billOrderField.map(rules => {
                    this.billOrderDisplayRules.push({
                        name: rules?.name,
                        fieldName: rules?.fieldName
                    });
                });
            }
        }

        //SalesOrder Result
        if (results?.salesOrderResultCount > 0) {

            const salesOrderResults: ElasticSearchResultModels[] = [];

            let flatData = this.getSalesOrderFlatData(results?.salesOrderResults);

            flatData.map(details => {
                salesOrderResults.push({
                    title: details?.name || details?.sonumber,
                    subTitle: ``,
                    contentDetails: details
                })
            });

            const resultExist = this.searchResults.find(m => m.modulePath === this.globalSearchPath.SalesOrder);

            if (resultExist) {
                resultExist.searchResults = [...salesOrderResults];
            } else {
                this.searchResults.push({
                    tabName: `SalesOrder (${results?.salesOrderResultCount})`,
                    modulePath: this.globalSearchPath.SalesOrder,
                    moduleName: this.globalSearchModuleName.SalesOrder,
                    searchResults: [...salesOrderResults]
                });
            }

            if (results?.fieldDisplayRule[0]?.salesOrderField?.length > 0) {
                this.salesOrderDisplayRules = [];
                results?.fieldDisplayRule[0]?.salesOrderField.map(rules => {
                    this.salesOrderDisplayRules.push({
                        name: rules?.name,
                        fieldName: rules?.fieldName
                    });
                });
            }
        }

        //Estimate Result
        if (results?.estimateResultCount > 0) {

            const estimateResults: ElasticSearchResultModels[] = [];

            let flatData = this.getEstimateFlatData(results?.estimateResults);

            flatData.map(details => {
                estimateResults.push({
                    title: details?.name || details?.estimatenumber,
                    subTitle: ``,
                    contentDetails: details
                })
            });

            const resultExist = this.searchResults.find(m => m.modulePath === this.globalSearchPath.Estimate);
            if (resultExist) {
                resultExist.searchResults = [...estimateResults];
            } else {
                this.searchResults.push({
                    tabName: `Estimate (${results?.estimateResultCount})`,
                    modulePath: this.globalSearchPath.Estimate,
                    moduleName: this.globalSearchModuleName.Estimate,
                    searchResults: [...estimateResults]
                });
            }

            if (results?.fieldDisplayRule[0]?.estimateField?.length > 0) {
                this.estimateDisplayRules = [];
                results?.fieldDisplayRule[0]?.estimateField.map(rules => {
                    this.estimateDisplayRules.push({
                        name: rules?.name,
                        fieldName: rules?.fieldName
                    });
                });
            }
        }

        //Invoice Result
        if (results?.invoiceResultCount > 0) {

            const invoiceResults: ElasticSearchResultModels[] = [];

            let flatData = this.getInvoiceFlatData(results?.invoiceResults);

            flatData.map(details => {
                invoiceResults.push({
                    title: details?.name || details?.invoicenumber,
                    subTitle: ``,
                    contentDetails: details
                })
            });

            const resultExist = this.searchResults.find(m => m.modulePath === this.globalSearchPath.Invoice);
            if (resultExist) {
                resultExist.searchResults = [...invoiceResults];
            } else {
                this.searchResults.push({
                    tabName: `Invoice (${results?.invoiceResultCount})`,
                    modulePath: this.globalSearchPath.Invoice,
                    moduleName: this.globalSearchModuleName.Invoice,
                    searchResults: [...invoiceResults]
                });
            }

            if (results?.fieldDisplayRule[0]?.invoiceField?.length > 0) {
                this.invoiceDisplayRules = [];
                results?.fieldDisplayRule[0]?.invoiceField.map(rules => {
                    this.invoiceDisplayRules.push({
                        name: rules?.name,
                        fieldName: rules?.fieldName
                    });
                });
            }
        }



        //Cases Details Format
        if (results?.caseResultCount > 0) {
            const casesResults: ElasticSearchResultModels[] = [];

            let flatData = this.getCasesFlatData(results?.caseResults);
            flatData.map(details => {
                casesResults.push({
                    title: details?.caseno ? details?.caseno : details?.sequencenumber,
                    subTitle: `Channel: ${details?.channelname}`,
                    contentDetails: details
                })
            });

            const resultExist = this.searchResults.find(m => m.modulePath === this.globalSearchPath.Case);
            if (resultExist) {
                resultExist.searchResults = [...casesResults];
            } else {
                this.searchResults.push({
                    tabName: `Cases (${results?.caseResultCount})`,
                    modulePath: this.globalSearchPath.Case,
                    moduleName: this.globalSearchModuleName.Case,
                    searchResults: [...casesResults]
                });
            }

            if (results?.fieldDisplayRule[0]?.caseField?.length > 0) {
                this.casesDisplayRules = [];
                results?.fieldDisplayRule[0]?.caseField.map(rules => {
                    this.casesDisplayRules.push({
                        name: rules?.name,
                        fieldName: rules?.fieldName
                    });
                });
            }
        }

        // Territory Details
        if (results?.territoryResultCount > 0) {
            const territoryResults: ElasticSearchResultModels[] = [];

            let flatData = this.getTerritoryFlatData(results?.territoryResults);
            flatData.map(details => {
                territoryResults.push({
                    title: details?.territoryname,
                    subTitle: `Channel: ${details?.channelname}`,
                    contentDetails: details
                })
            });

            const resultExist = this.searchResults.find(m => m.modulePath === this.globalSearchPath.Territory);
            if (resultExist) {
                resultExist.searchResults = [...territoryResults];
            } else {
                this.searchResults.push({
                    tabName: `Territory (${results?.territoryResultCount})`,
                    modulePath: this.globalSearchPath.Territory,
                    moduleName: this.globalSearchModuleName.Territory,
                    searchResults: [...territoryResults]
                });
            }

            if (results?.fieldDisplayRule[0]?.territoryField?.length > 0) {
                this.territoryDisplayRules = [];
                results?.fieldDisplayRule[0]?.territoryField.map(rules => {
                    this.territoryDisplayRules.push({
                        name: rules?.name,
                        fieldName: rules?.fieldName
                    });
                });
            }
        }

        //Serial No Details Format
        if (results?.serialNoResultCount > 0) {
            const serialNoResults: ElasticSearchResultModels[] = [];
            let flatData = this.getSerialNoFlatData(results?.serialNoResults);
            flatData.map(details => {


                const serialNoDetails: any[] = [
                    {
                        tabHeader: "Product",
                        modulePath: this.globalSearchPath.Product,
                        details: {
                            title: details.productdetails[0].itemno,
                            contentDetails: details.productdetails[0]
                        }
                    }
                ];

                if (details?.purchaseorder?.length > 0) {
                    serialNoDetails.push(
                        {
                            tabHeader: "Purchase Order",
                            modulePath: this.globalSearchPath.Purchases,
                            details: {
                                title: details?.purchaseorder[0].ponumber,
                                contentDetails: details.purchaseorder[0]
                            }
                        }
                    )
                }

                if (details?.billorder?.length > 0) {
                    serialNoDetails.push(
                        {
                            tabHeader: "Bill Order",
                            modulePath: this.globalSearchPath.BillOrder,
                            details: {
                                title: details.billorder[0].billnumber,
                                contentDetails: details.billorder[0]
                            }
                        }
                    )
                }

                if (details?.salesorder?.length > 0) {
                    serialNoDetails.push(
                        {
                            tabHeader: "Sales Order",
                            modulePath: this.globalSearchPath.SalesOrder,
                            details: {
                                title: details.salesorder[0].sonumber,
                                contentDetails: details.salesorder[0]
                            }
                        }
                    )
                }

                if (details?.invoice?.length > 0) {
                    serialNoDetails.push(
                        {
                            tabHeader: "Invoice",
                            modulePath: this.globalSearchPath.Invoice,
                            details: {
                                title: details.invoice[0].invoicenumber,
                                contentDetails: details.invoice[0]
                            }
                        }
                    )
                }

                if (details?.estimate?.length > 0) {
                    serialNoDetails.push(
                        {
                            tabHeader: "Estimates",
                            modulePath: this.globalSearchPath.Estimate,
                            details: {
                                title: details.estimate[0].estimatenumber,
                                contentDetails: details.estimate[0]
                            }
                        }
                    )
                }

                if (details?.inventorytransfer?.length > 0) {
                    serialNoDetails.push(
                        {
                            tabHeader: "Inventory Transfer",
                            modulePath: this.globalSearchPath.InventoryTransfer,
                            details: {
                                title: details.inventorytransfer[0].name,
                                contentDetails: details.inventorytransfer[0]
                            }
                        }
                    )
                }

                if (details?.inventoryadjustment?.length > 0) {
                    serialNoDetails.push(
                        {
                            tabHeader: "Inventory Adjustment",
                            modulePath: this.globalSearchPath.InventoryAdjustment,
                            details: {
                                title: details.inventoryadjustment[0].name,
                                contentDetails: details.inventoryadjustment[0]
                            }
                        }
                    )
                }

                if (details?.customerrma?.length > 0) {
                    serialNoDetails.push(
                        {
                            tabHeader: "Customer RMA",
                            modulePath: this.globalSearchPath.CustomerRma,
                            details: {
                                title: details.customerrma[0].rmanumber,
                                contentDetails: details.customerrma[0]
                            }
                        }
                    )
                }

                if (details?.creditmemo?.length > 0) {
                    serialNoDetails.push(
                        {
                            tabHeader: "Credit Memo",
                            modulePath: this.globalSearchPath.CreditMemo,
                            details: {
                                title: details.creditmemo[0].cmnumber,
                                contentDetails: details.creditmemo[0]
                            }
                        }
                    )
                }

                details['serialNoDetails'] = serialNoDetails;

                serialNoResults.push({
                    title: details?.serialno,
                    subTitle: `Item: ${details.productdetails[0].itemno}`,
                    contentDetails: details
                })
            });

            const resultExist = this.searchResults.find(m => m.modulePath === this.globalSearchPath.SerialNo);
            if (resultExist) {
                resultExist.searchResults = [...serialNoResults];
            } else {
                this.searchResults.push({
                    tabName: `Serial-No. (${results?.serialNoResultCount})`,
                    modulePath: this.globalSearchPath.SerialNo,
                    moduleName: this.globalSearchModuleName.SerialNo,
                    searchResults: [...serialNoResults]
                });
            }


            if (results?.fieldDisplayRule[0]?.serialNoField?.length > 0) {
                this.serialNoDisplayRules = [];
                results?.fieldDisplayRule[0]?.serialNoField.sort(
                    (p1, p2) => (p2?.displayOrder < p1?.displayOrder) ? 1 : (p2?.displayOrder > p1?.displayOrder) ? -1 : 0).map(rules => {
                        this.serialNoDisplayRules.push({
                            name: rules?.name,
                            fieldName: rules?.fieldName,
                            displayOrder: rules?.displayOrder,
                            sectionId: rules?.sectionId
                        });
                    });
            }
        }

        // Customer RMA Detail Format
        if (results?.customerRMAResultsCount > 0) {
            const customerRMAResults: ElasticSearchResultModels[] = [];
            let flatData = this.getCustomerRMAFlatData(results?.customerRMAResults);
            flatData.map(details => {
                customerRMAResults.push({
                    title: details?.rmanumber,
                    subTitle: ``,
                    contentDetails: details
                });
            });
            const resultExist = this.searchResults.find(m => m.modulePath === this.globalSearchPath.CustomerRma);
            if (resultExist) {
                resultExist.searchResults = [...customerRMAResults];
            } else {
                this.searchResults.push({
                    tabName: `CustomerRMA (${results?.customerRMAResultsCount})`,
                    modulePath: this.globalSearchPath.CustomerRma,
                    moduleName: this.globalSearchModuleName.CustomerRma,
                    searchResults: [...customerRMAResults]
                });
            }

            if (results?.fieldDisplayRule[0]?.customerRMAField?.length > 0) {
                this.customerRMADisplayRules = [];
                results?.fieldDisplayRule[0]?.customerRMAField.sort(
                    (p1, p2) => (p2?.displayOrder < p1?.displayOrder) ? 1 : (p2?.displayOrder > p1?.displayOrder) ? -1 : 0).map(rules => {
                        this.customerRMADisplayRules.push({
                            name: rules?.name,
                            fieldName: rules?.fieldName,
                            displayOrder: rules?.displayOrder,
                            sectionId: rules?.sectionId
                        });
                    });
            }
        }

        // Credit Memo Format
        if (results?.creditMemoResultCount > 0) {
            const creditMemoResults: ElasticSearchResultModels[] = [];
            let flatData = this.getCreditMemoFlatData(results?.creditMemoResults);
            flatData.map(details => {
                creditMemoResults.push({
                    title: details?.cmnumber,
                    subTitle: ``,
                    contentDetails: details
                });
            });
            const resultExist = this.searchResults.find(m => m.modulePath === this.globalSearchPath.CreditMemo);
            if (resultExist) {
                resultExist.searchResults = [...creditMemoResults];
            } else {
                this.searchResults.push({
                    tabName: `CreditMemo (${results?.creditMemoResultCount})`,
                    modulePath: this.globalSearchPath.CreditMemo,
                    moduleName: this.globalSearchModuleName.CreditMemo,
                    searchResults: [...creditMemoResults]
                });
            }

            if (results?.fieldDisplayRule[0]?.creditMemoField?.length > 0) {
                this.creditMemoDisplayRules = [];
                results?.fieldDisplayRule[0]?.creditMemoField.sort(
                    (p1, p2) => (p2?.displayOrder < p1?.displayOrder) ? 1 : (p2?.displayOrder > p1?.displayOrder) ? -1 : 0).map(rules => {
                        this.creditMemoDisplayRules.push({
                            name: rules?.name,
                            fieldName: rules?.fieldName,
                            displayOrder: rules?.displayOrder,
                            sectionId: rules?.sectionId
                        });
                    });
            }
        }
        if (!selectedTabName) {
            this.selectedTabIndex = this.searchResults.findIndex(tab => tab.searchResults.length > 0);
        }

        if (this.searchResults.length === 0) {
            this.searchHistory = [];
        }

        //console.log('accountDisplayRules', this.accountDisplayRules);

    }

    clearSearch() {
        this.searchControl.patchValue("");
        this.showSearchSuggestions = false;
        this.isSeachFromHistoty = false;
        this.moduleSuggestionResults = [];
        this.moduleFieldsSuggestionResults = [];
        this.SearchInput.nativeElement.focus();
    }

    navigateToDetailsPage(tabDetails: ElasticSearchResultsViewModels, itemDetails: ElasticSearchResultModels) {
        switch (tabDetails.modulePath) {
            case this.globalSearchPath.Account:
                this.crmNavigation(tabDetails.modulePath, ObjectNames.ACCOUNT, itemDetails)
                break;
            case this.globalSearchPath.Contact:
                this.crmNavigation(tabDetails.modulePath, ObjectNames.CONTACT, itemDetails)
                break;
            case this.globalSearchPath.Lead:
                this.crmNavigation(tabDetails.modulePath, ObjectNames.LEAD, itemDetails)
                break;
            case this.globalSearchPath.Case:
                this.crmNavigation(tabDetails.modulePath, ObjectNames.CASES, itemDetails)
                break;
            case this.globalSearchPath.Opportunity:
                this.crmNavigation(tabDetails.modulePath, ObjectNames.OPPORTUNITY, itemDetails)
                break;
            case this.globalSearchPath.Product:
                switch (itemDetails.contentDetails?.channelid) {
                    case ProductSubModule.Inventory:
                        tabDetails.modulePath = 'inventory-items';
                        break;
                    case ProductSubModule.Service:
                        tabDetails.modulePath = 'services';
                        break;
                    case ProductSubModule.NonInventory:
                        tabDetails.modulePath = 'non-inventory';
                        break;
                    case ProductSubModule.Bundle:
                        tabDetails.modulePath = 'bundle-items';
                        break;
                    default:
                        tabDetails.modulePath = 'kit-items';
                        break;
                }
                this.crmNavigation(tabDetails.modulePath, ObjectNames.PRODUCT, itemDetails)
                break;
            case this.globalSearchPath.Purchases:
                switch (itemDetails.contentDetails?.channelid) {
                    case PurchaseSubModule.Purchas_eOrder:
                        tabDetails.modulePath = 'purchase-order';
                        break;
                    case PurchaseSubModule.Item_Receipt:
                        tabDetails.modulePath = 'item-receipt';
                        break;
                    case PurchaseSubModule.Bill:
                        tabDetails.modulePath = 'bill';
                        break;
                    case PurchaseSubModule.Bill_Payment:
                        tabDetails.modulePath = 'bill-payment';
                        break;
                    case PurchaseSubModule.Vendors:
                        tabDetails.modulePath = 'vendors';
                        break;
                    case PurchaseSubModule.Vendor_Return:
                        tabDetails.modulePath = 'vendor-return';
                        break;
                    default:
                        tabDetails.modulePath = 'vendor-credit';
                        break;
                }
                this.crmNavigation(tabDetails.modulePath, ObjectNames.PURCHASE, itemDetails)
                break;
            case this.globalSearchPath.SalesOrder:
                this.crmNavigation(tabDetails.modulePath, ObjectNames.SALES_ORDER, itemDetails)
                break;
            case this.globalSearchPath.Invoice:
                this.crmNavigation(tabDetails.modulePath, ObjectNames.INVOICE, itemDetails)
                break;
            case this.globalSearchPath.CreditMemo:
                this.crmNavigation(tabDetails.modulePath, ObjectNames.CREDIT_MEMO, itemDetails)
                break;
            case this.globalSearchPath.CustomerRma:
                this.crmNavigation(tabDetails.modulePath, ObjectNames.CREDIT_RMA, itemDetails)
                break;
            case this.globalSearchPath.Estimate:
                this.crmNavigation(tabDetails.modulePath, ObjectNames.ESTIMATE, itemDetails)
                break;
            // case this.globalSearchPath.BillOrder:
            //     this.crmNavigation(tabDetails.modulePath, ObjectNames.BILL_ORDER, itemDetails)
            //     break;
            case this.globalSearchPath.Territory:
                this.crmNavigation(tabDetails.modulePath, ObjectNames.TERRITORY, itemDetails)
                break;
            default:
                break;
        }

        this.showSearchSuggestions = false;
    }

    crmNavigation(modulePath: string, moduleName: string, itemDetails: ElasticSearchResultModels) {

        let queryParams: any = {
            id: itemDetails.contentDetails?.id,
            module: moduleName,
            channelId: itemDetails.contentDetails?.channelid,
            statusId: itemDetails.contentDetails?.statusid,
            globalSearch: true,
            data: removeHTMLTags(itemDetails.title)
        };

        if (itemDetails.contentDetails?.associationtypeid) {
            queryParams = {
                ...queryParams,
                assocTypeId: itemDetails.contentDetails?.associationtypeid
            }
        }

        this.router
            .navigateByUrl("/", { skipLocationChange: true })
            .then(() =>
                this.router.navigate([modulePath], {
                    queryParams: queryParams
                })
            );
    }

    inVoiceNavigation(detail, item) {
        this.showSearchSuggestions = false;
        let queryParams: any = {
            id: detail?.id,
            module: ObjectNames?.INVOICE,
            channelId: detail?.channelid,
            statusId: detail?.statusid,
            globalSearch: true,
            data: removeHTMLTags(detail.invoiceno)
        };

        if (item?.id) {
            queryParams = {
                ...queryParams,
                // assocTypeId: item?.id
            }
        }

        this.router
            .navigateByUrl("/", { skipLocationChange: true })
            .then(() =>
                this.router.navigate(['invoicing'], {
                    queryParams: queryParams
                })
            );
    }

    clickOutside(clicked: boolean) {
        this.showSearchSuggestions = !clicked;
    }

    getAccountFlatData(data: any) {
        return data.map((accountData) => {
            if (accountData.customproperties && accountData.customproperties.length > 0) {
                accountData.customproperties.map((cf) => {
                    accountData[cf?.fieldname] = cf?.value;
                })
            }

            if (accountData.accountcontacts && accountData.accountcontacts.length > 0) {
                const accountContactDetails = accountData.accountcontacts[0];
                accountData['contactfirstname'] = accountContactDetails?.contactfirstname;
                accountData['contactlastname'] = accountContactDetails?.contactlastname;
                accountData['contactmiddlename'] = accountContactDetails?.contactmiddlename;

                if (accountContactDetails?.contactemails) {
                    accountContactDetails?.contactemails.map(element => {
                        accountData[element?.fieldname] = element?.value;
                    });
                }

                if (accountContactDetails?.contactphones) {
                    accountContactDetails?.contactphones.map(element => {
                        accountData[element?.fieldname] = element?.value;
                    });
                }

                if (accountContactDetails?.contactsocials && accountContactDetails?.contactsocials?.lenght > 0) {
                    accountContactDetails?.contactsocials?.map(element => {
                        accountData[element?.fieldname] = element?.value;
                    });
                }
                if (accountContactDetails?.socials) {
                    accountContactDetails?.socials.map(element => {
                        accountData[element?.fieldname] = element?.value;
                    });
                }


            }

            if (accountData.accountaddresses && accountData.accountaddresses.length > 0) {
                const accountAddress = accountData.accountaddresses[0];
                accountData['city'] = accountAddress?.city;
                accountData['country'] = accountAddress?.country;
                accountData['state'] = accountAddress?.state;
                accountData['streetaddress1'] = accountAddress?.streetaddress1;
                accountData['streetaddress2'] = accountAddress?.streetaddress2;
                accountData['zipcode'] = accountAddress?.zipcode;
            }

            if (accountData?.accountemails && accountData.accountemails?.length > 0) {
                accountData.accountemails.map((element) => {
                    accountData[element?.fieldname] = element?.value;
                })
            }

            if (accountData?.accountphones && accountData.accountphones?.length > 0) {
                accountData.accountphones.map((element) => {
                    accountData[element?.fieldname] = element?.value;
                })
            }

            if (accountData?.accountsocials && accountData.accountsocials?.length > 0) {
                accountData.accountsocials.map((element) => {
                    accountData[element?.fieldname] = element?.value;
                })
            }

            const modifiedData = { ...accountData }
            return modifiedData;
        })
    }

    getContactFlatData(data: any) {
        return data.map((contactData) => {
            if (contactData?.customproperties && contactData.customproperties?.length > 0) {
                contactData.customProperties.map((cf) => {
                    contactData[cf?.fieldname] = cf?.value;
                })
            }

            if (contactData?.contactemails && contactData?.contactemails?.length > 0) {
                contactData.contactemails.map((element) => {
                    contactData[element?.fieldname] = element?.value;
                })
            }

            if (contactData?.contactphones && contactData.contactphones?.length > 0) {
                contactData.contactphones.map((element) => {
                    contactData[element?.fieldname] = element?.value;
                })
            }

            if (contactData?.contactsocials && contactData.contactsocials?.length > 0) {
                contactData.contactsocials.map((element) => {
                    contactData[element?.fieldname] = element?.value;
                })
            }

            contactData['contactfirstname'] = contactData?.contactfirstname;
            contactData['contactlastname'] = contactData?.contactlastname;
            contactData['contactmiddlename'] = contactData?.contactmiddlename;
            contactData['contactname'] = `${contactData?.contactfirstname || ""} ${contactData?.contactmiddlename || ""} ${contactData?.contactlastname || ""}`;

            const modifiedData = { ...contactData }
            return modifiedData;
        })
    }

    getLeadFlatData(data: any) {
        return data.map((leadData) => {
            if (leadData.customproperties && leadData.customproperties.length > 0) {
                leadData.customproperties.map((cf) => {
                    leadData[cf?.fieldname] = cf?.value;
                })
            }

            if (leadData.leadcontacts && leadData.leadcontacts.length > 0) {
                const leadContactDetails = leadData.leadcontacts[0];
                leadData['contactfirstname'] = leadContactDetails?.contactfirstname;
                leadData['contactlastname'] = leadContactDetails?.contactlastname;
                leadData['contactmiddlename'] = leadContactDetails?.contactmiddlename;

                if (leadContactDetails?.contactemails) {
                    leadContactDetails?.contactemails.map(element => {
                        leadData[element?.fieldname] = element?.value;
                    });
                }


                if (leadContactDetails?.contactphones) {
                    leadContactDetails?.contactphones.map(element => {
                        leadData[element?.fieldname] = element?.value;
                    });
                }

                if (leadContactDetails?.contactsocials && leadContactDetails?.contactsocials?.length > 0) {
                    leadContactDetails?.contactsocials?.map(element => {
                        leadData[element?.fieldname] = element?.value;
                    });
                }
            }

            if (leadData.leadaddresses && leadData.leadaddresses.length > 0) {
                const leadAddress = leadData.leadaddresses[0];
                leadData['city'] = leadAddress?.city;
                leadData['country'] = leadAddress?.country;
                leadData['state'] = leadAddress?.state;
                leadData['streetaddress1'] = leadAddress?.streetaddress1;
                leadData['streetaddress2'] = leadAddress?.streetaddress2;
                leadData['zipcode'] = leadAddress?.zipcode;
            }

            if (leadData?.leademails && leadData.leademails?.length > 0) {
                leadData.leademails.map((element) => {
                    leadData[element?.fieldname] = element?.value;
                })
            }

            if (leadData?.leadphones && leadData.leadphones?.length > 0) {
                leadData.leadphones.map((element) => {
                    leadData[element?.fieldname] = element?.value;
                })
            }

            if (leadData?.leadsocials && leadData.leadsocials?.length > 0) {
                leadData.leadsocials.map((element) => {
                    leadData[element?.fieldname] = element?.value;
                })
            }

            const modifiedData = { ...leadData }
            return modifiedData;
        })
    }

    getOpportunityFlatData(data: any) {
        return data.map((opportunityData) => {
            if (opportunityData.customproperties && opportunityData.customproperties.length > 0) {
                opportunityData.customproperties.map((cf) => {
                    opportunityData[cf?.fieldname] = cf?.value;
                })
            }

            const modifiedData = { ...opportunityData }
            return modifiedData;
        })
    }

    getProductsFlatData(data: any) {
        return data;
    }


    getPurchaseOrderFlatData(data: any) {
        return data;
    }


    getBillOrderFlatData(data: any) {
        return data;
    }

    getSalesOrderFlatData(data: any) {
        return data;
    }

    getEstimateFlatData(data: any) {
        return data;
    }

    getTerritoryFlatData(data: any) {
        return data;
    }

    getInvoiceFlatData(data: any) {
        return data;
    }




    getCasesFlatData(data: any) {
        return data;
    }


    getSerialNoFlatData(data: any) {
        return data;
    }

    getCustomerRMAFlatData(data: any) {
        return data;
    }

    getCreditMemoFlatData(data: any) {
        return data;
    }

    goSeachFromHistory(history: SingleHistory): void {
        this.isSeachFromHistoty = true;
        this.searchControl.setValue(history.value);
        //this.onGlobalSearch(history.value);
    }

    clickModuleSuggestion(data: ModuleSuggestion): void {
        // For module wise specification, here switch/case are using
        switch (data?.module) {
            case AccountModuleName:
                this.searchControl.setValue(`${data?.pluralName}:`);
                this.SearchInput.nativeElement.focus();
                this.moduleSuggestionResults = JSON.parse(JSON.stringify([]));
            case ContactModuleName:
                this.searchControl.setValue(`${data?.pluralName}:`);
                this.SearchInput.nativeElement.focus();
                this.moduleSuggestionResults = JSON.parse(JSON.stringify([]));
            case LeadModuleName:
                this.searchControl.setValue(`${data?.pluralName}:`);
                this.SearchInput.nativeElement.focus();
                this.moduleSuggestionResults = JSON.parse(JSON.stringify([]));
            case OpportunityModuleName:
                this.searchControl.setValue(`${data?.pluralName}:`);
                this.SearchInput.nativeElement.focus();
                this.moduleSuggestionResults = JSON.parse(JSON.stringify([]));
            case ProductModuleName:
                this.searchControl.setValue(`${data?.pluralName}:`);
                this.SearchInput.nativeElement.focus();
                this.moduleSuggestionResults = JSON.parse(JSON.stringify([]));
            case CaseModuleName:
                this.searchControl.setValue(`${data?.pluralName}:`);
                this.SearchInput.nativeElement.focus();
                this.moduleSuggestionResults = JSON.parse(JSON.stringify([]));
            case BillOrderModuleName:
                this.searchControl.setValue(`${data?.pluralName}:`);
                this.SearchInput.nativeElement.focus();
                this.moduleSuggestionResults = JSON.parse(JSON.stringify([]));
            case CustomerRmaModuleName:
                this.searchControl.setValue(`${data?.pluralName}:`);
                this.SearchInput.nativeElement.focus();
                this.moduleSuggestionResults = JSON.parse(JSON.stringify([]));
            case EstimateModuleName:
                this.searchControl.setValue(`${data?.pluralName}:`);
                this.SearchInput.nativeElement.focus();
                this.moduleSuggestionResults = JSON.parse(JSON.stringify([]));
            case InvoiceModuleName:
                this.searchControl.setValue(`${data?.pluralName}:`);
                this.SearchInput.nativeElement.focus();
                this.moduleSuggestionResults = JSON.parse(JSON.stringify([]));
            case PurchaseOrderModuleName:
                this.searchControl.setValue(`${data?.pluralName}:`);
                this.SearchInput.nativeElement.focus();
                this.moduleSuggestionResults = JSON.parse(JSON.stringify([]));
            case SalesOrderModuleName:
                this.searchControl.setValue(`${data?.pluralName}:`);
                this.SearchInput.nativeElement.focus();
                this.moduleSuggestionResults = JSON.parse(JSON.stringify([]));
            case TerritoryModuleName:
                this.searchControl.setValue(`${data?.pluralName}:`);
                this.SearchInput.nativeElement.focus();
                this.moduleSuggestionResults = JSON.parse(JSON.stringify([]));
            case SerialNoModuleName:
                this.searchControl.setValue(`${data?.pluralName}:`);
                this.SearchInput.nativeElement.focus();
                this.moduleSuggestionResults = JSON.parse(JSON.stringify([]));
            case CreditMemo:
                this.searchControl.setValue(`${data?.pluralName}:`);
                this.SearchInput.nativeElement.focus();
                this.moduleSuggestionResults = JSON.parse(JSON.stringify([]));
        }
    }

    clickModuleFieldsSuggestion(data: ModuleFieldSuggestion): void {
        const splitedSearchValue = this.searchControl.value.split(':');

        if (data?.fieldName && splitedSearchValue.length > 0) {
            this.searchControl.setValue(`${splitedSearchValue[0]}:${data?.fieldName}:`);
            this.SearchInput.nativeElement.focus();
            this.moduleFieldsSuggestionResults = JSON.parse(JSON.stringify([]));;
        }
    }

    onArrowUp($event) {
        $event.preventDefault();

        const moduleLength = this.globalSearchModuleFilterPipe.transform(this.moduleSuggestionResults, this.moduleSearchValue)?.length || 0;
        const fieldLength = this.globalSearchFieldFilterPipe.transform(this.moduleFieldsSuggestionResults, this.moduleFieldsSearchValue)?.length || 0;
        const listLength = this.moduleSearchType == GlobalSearchModuleSearch.MODULE ? moduleLength : fieldLength;

        if (this.searchFocusElement > 0) {
            this.searchFocusElement--;
        } else {
            this.searchFocusElement = (listLength - 1);
        }

        setTimeout(() => {
            this.scrollToActive();
        });

    }

    onArrowDown($event) {
        $event.preventDefault();

        const moduleLength = this.globalSearchModuleFilterPipe.transform(this.moduleSuggestionResults, this.moduleSearchValue)?.length || 0;
        const fieldLength = this.globalSearchFieldFilterPipe.transform(this.moduleFieldsSuggestionResults, this.moduleFieldsSearchValue)?.length || 0;
        const listLength = this.moduleSearchType == GlobalSearchModuleSearch.MODULE ? moduleLength : fieldLength;

        if (this.searchFocusElement < (listLength - 1)) {
            this.searchFocusElement++;
        } else {
            this.searchFocusElement = 0;
        }

        setTimeout(() => {
            this.scrollToActive();
        });
    }

    searchEnterPress() {
        const moduleList = this.globalSearchModuleFilterPipe.transform(this.moduleSuggestionResults, this.moduleSearchValue);
        const fieldList = this.globalSearchFieldFilterPipe.transform(this.moduleFieldsSuggestionResults, this.moduleFieldsSearchValue);
        const listLength = this.moduleSearchType == GlobalSearchModuleSearch.MODULE ? moduleList.length : fieldList.length;

        if (listLength > 0 && this.searchFocusElement >= 0 && this.searchFocusElement < listLength) {

            switch (this.moduleSearchType) {
                case GlobalSearchModuleSearch.MODULE:
                    this.clickModuleSuggestion(moduleList[this.searchFocusElement]);
                    break;
                case GlobalSearchModuleSearch.FIELD:
                    this.clickModuleFieldsSuggestion(fieldList[this.searchFocusElement]);
                    break;
                default:
                    break;
            }
        }
    }

    scrollTo(el: Element): void {
        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    // Scroll to error handler function
    scrollToActive(): void {
        const firstElementWithError = document.querySelector('.elastic-search-list li.active');
        this.scrollTo(firstElementWithError);

        if (!firstElementWithError) {
            const secondElementWithError = document.querySelector('.active');
            this.scrollTo(secondElementWithError);
        }
    }

    changeTab(e) {
        this.selectedTabIndex = e.index;
        const selectedTabName = this.searchResults[this.selectedTabIndex].moduleName;
        const searchValue = selectedTabName + ':' + this.searchControl.value;

        if (this.searchResults[this.selectedTabIndex].searchResults.length === 0) {
            this.onGlobalSearch(searchValue, selectedTabName);
        }

    }

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

}
